import { render, staticRenderFns } from "./SynaqDomain.vue?vue&type=template&id=0143ae1a&scoped=true&"
import script from "./SynaqDomain.vue?vue&type=script&lang=js&"
export * from "./SynaqDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143ae1a",
  null
  
)

export default component.exports